import { Action } from '@ngrx/store';
import { TAddEditRowType, TLearningCurveInfoActionType } from './learning-curve.models';
import {
  TRESPONSE_LEARNING_CURVE_DETAILS,
  TREQUEST_LEARNING_CURVE_DETAILS,
  TREQUEST_DELETE_LEARNING_CURVES,
  TREQUEST_ADD_LEARNING_CURVE_DAY,
  TLearningCurveDTO,
} from '@monorepo/types';
import { TLiftedFormModel, TUserPaginationOption } from '@monorepo/ui';

export class GetLearningCurvesInfo implements Action {
  readonly type = TLearningCurveInfoActionType.GetLearningCurveInfo;
  constructor(public fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS) {}
}

export class GetLearningCurvesInfoSuccess implements Action {
  readonly type = TLearningCurveInfoActionType.GetLearningCurveInfoSuccess;
  constructor(public learningCurveRes: TRESPONSE_LEARNING_CURVE_DETAILS) {}
}

export class GetLearningCurvesInfoFailure implements Action {
  readonly type = TLearningCurveInfoActionType.GetLearningCurveInfoFailure;
}

export class SetUserPaginationOption implements Action {
  readonly type = TLearningCurveInfoActionType.SetUserPaginationOption;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export class AddEditLearningCurve implements Action {
  readonly type = TLearningCurveInfoActionType.AddEditLearningCurve;
  constructor(
    public learningCurves: TLearningCurveDTO,
    public fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS,
    public addEditType: TAddEditRowType,
  ) {}
}

export class AddEditLearningCurveSuccess implements Action {
  readonly type = TLearningCurveInfoActionType.AddEditLearningCurveSuccess;
}

export class AddEditLearningCurveFailure implements Action {
  readonly type = TLearningCurveInfoActionType.AddEditLearningCurveFailure;
}

export class DeleteLearningCurves implements Action {
  readonly type = TLearningCurveInfoActionType.DeleteLearningCurves;
  constructor(
    public learningCurvesIds: TREQUEST_DELETE_LEARNING_CURVES,
    public fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS,
  ) {}
}
export class DeleteLearningCurvesSuccess implements Action {
  readonly type = TLearningCurveInfoActionType.DeleteLearningCurvesSuccess;
}

export class DeleteLearningCurvesFailure implements Action {
  readonly type = TLearningCurveInfoActionType.DeleteLearningCurvesFailure;
}

export class AddLearningCurvesDay implements Action {
  readonly type = TLearningCurveInfoActionType.AddLearningCurveDay;
  constructor(
    public currDays: TREQUEST_ADD_LEARNING_CURVE_DAY,
    public fetchLearningCurvePayload: TREQUEST_LEARNING_CURVE_DETAILS,
  ) {}
}
export class AddLearningCurvesDaySuccess implements Action {
  readonly type = TLearningCurveInfoActionType.AddEditLearningCurveSuccess;
}

export class AddLearningCurvesDayFailure implements Action {
  readonly type = TLearningCurveInfoActionType.AddEditLearningCurveFailure;
}

export type TLearningCurveActions =
  | GetLearningCurvesInfo
  | GetLearningCurvesInfoSuccess
  | GetLearningCurvesInfoFailure
  | SetUserPaginationOption
  | AddEditLearningCurve
  | AddEditLearningCurveSuccess
  | AddEditLearningCurveFailure
  | DeleteLearningCurves
  | DeleteLearningCurvesSuccess
  | DeleteLearningCurvesFailure
  | AddLearningCurvesDay
  | AddLearningCurvesDaySuccess
  | AddLearningCurvesDayFailure;
